export default class Widget {
    private readonly vue: any;
    private readonly mainComponent: any;

    constructor (vue: any) {
        this.vue = vue;
        this.mainComponent = vue.$root.$children[0];
    }

    /**
     * An object containing the user defined options for this widget.
     * @return {Object}
     */
    get options() {
        return this.vue.$root.dmnOptions;
    }

    set options (options) {
        this.vue.$root.dmnOptions = options;
    }
}